import { SupportedChainId as ChainId } from "../constants/chains";

export const DEFAULT_ARCHER_ETH_TIP = "";
// default archer gas estimate, 250k wei
export const DEFAULT_ARCHER_GAS_ESTIMATE = 250000;
export const DEFAULT_ARCHER_GAS_PRICES = [
  60000000000, 70000000000, 70000000000, 70000000000, 70000000000,
];

export const ARCHER_RELAY_URI: { [chainId in ChainId]?: string } = {
  // [ChainId.MAINNET]: "https://api.archerdao.io/v1/transaction",
};

export const ARCHER_GAS_URI: { [chainId in ChainId]?: string } = {
  // [ChainId.MAINNET]: "https://api.archerdao.io/v1/gas",
};
